import { render, staticRenderFns } from "./RestSoap.vue?vue&type=template&id=7961e4f3&scoped=true&"
import script from "./RestSoap.vue?vue&type=script&lang=js&"
export * from "./RestSoap.vue?vue&type=script&lang=js&"
import style0 from "./RestSoap.vue?vue&type=style&index=0&id=7961e4f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7961e4f3",
  null
  
)

export default component.exports